import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import { ARCADE_GAMES } from '../../arcade/games';
import { buildArcadeProxy } from '../../../lib/adventCalendar';

/**
 * Game door: mounts one arcade game. The game posts to the global arcade table through
 * `arcadeScoreStore.submitScore`; we hand it the proxy from lib/adventCalendar.js that forwards
 * every read and call to the real store and also posts the run to the calendar's day score.
 */
@observer
class AdventGameDoor extends Component {
    constructor(props) {
        super(props);
        this.state = { playing: false };
    }

    proxyStores() {
        const { stores, day } = this.props;
        const { adventCalendarStore } = stores;
        const proxy = buildArcadeProxy({
            real: stores.arcadeScoreStore,
            onSubmit: payload => adventCalendarStore.submitGameScore(day, {
                score: payload.score, durationMs: payload.durationMs,
            }),
        });
        return { ...stores, arcadeScoreStore: proxy };
    }

    render() {
        const { door = {}, day, drawerLevel } = this.props;
        const { adventCalendarStore } = this.props.stores;
        const { playing } = this.state;
        const entry = ARCADE_GAMES.find(g => g.key === door.content?.game);
        if (!entry) {
            return <div class='alert alert-warning'><Text id='adventCalendar.gameMissing'>This game is not available.</Text></div>;
        }
        const GameComponent = entry.component;
        const top = adventCalendarStore.gameTop[day] || [];
        return (
            <div>
                {playing ? (
                    <GameComponent
                        stores={this.proxyStores()}
                        drawerLevel={drawerLevel}
                        onBack={() => this.setState({ playing: false })}
                    />
                ) : (
                    <div class='text-center'>
                        <div style='font-size: 3rem;'>{entry.icon}</div>
                        <div class='fs-5 fw-bold mb-1'><Text id={entry.textKey}>{entry.title}</Text></div>
                        <div class='small text-body-secondary mb-3'>
                            <Text id='adventCalendar.gameIntro'>Today's door is a game. Best score in the club today wins bragging rights.</Text>
                        </div>
                        {door.gameScore > 0 ? (
                            <div class='mb-3'>
                                <Text id='adventCalendar.yourBest' fields={{ score: door.gameScore }}>Your best today: {door.gameScore}</Text>
                            </div>
                        ) : null}
                        <button type='button' class='btn btn-primary btn-lg' onClick={() => this.setState({ playing: true })}>
                            <i class='fa-solid fa-play me-2' /><Text id='adventCalendar.play'>Play</Text>
                        </button>
                    </div>
                )}
                {top.length > 0 ? (
                    <div class='card mt-3'>
                        <div class='card-body py-2'>
                            <div class='fw-bold mb-1'><Text id='adventCalendar.gameTopToday'>Today's top in the club</Text></div>
                            <table class='table table-sm mb-0'>
                                <tbody>
                                    {top.map(row => (
                                        <tr key={`advent-game-top-${row.user}`} class={row.isMe ? 'table-active fw-bold' : ''}>
                                            <td class='text-end' style='width: 40px;'>{row.rank}.</td>
                                            <td>{row.name}</td>
                                            <td class='text-end'>{row.gameScore}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

export default AdventGameDoor;
